import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyPubtTypeItemCss = ":host{--backgroundColor:#4A90E2;--color:#fff;--round:20px;background-color:var(--backgroundColor);color:var(--color);border-radius:var(--round);display:inline-flex;justify-content:flex-start;align-items:center;gap:4px;font-family:Arial, Helvetica, sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:16px;position:relative}::slotted(mapy-icon){display:block;width:20px;height:20px;fill:currentColor}::slotted(:first-child){margin-left:4px}::slotted(:last-child){margin-right:8px}::slotted(mapy-icon:only-child){width:24px;height:24px;margin:0}.delay{position:absolute;top:-6px;right:-7px}";

const DELAY_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
	<g filter="url(#a)">
		<mask id="b" width="12" height="12" x="3" y="2" maskUnits="userSpaceOnUse" style={{ mask-type: alpha }}">
			<path fill="#D9D9D9" d="M3 2h12v12H3z"/>
		</mask>
		<g mask="url(#b)">
			<path fill="#fff" fill-rule="evenodd" d="M8.55 7.813c0 .066.012.127.037.181a.495.495 0 0 0 .1.144L10.36 9.81c.093.093.2.137.32.133A.461.461 0 0 0 11 9.8a.437.437 0 0 0-.005-.64L9.449 7.625V5.45a.437.437 0 0 0-.128-.32A.432.432 0 0 0 9 5a.44.44 0 0 0-.32.13.432.432 0 0 0-.132.32v2.363Zm-4.895 2.444A5.69 5.69 0 0 1 3.2 7.994 5.764 5.764 0 0 1 4.902 3.89a5.893 5.893 0 0 1 1.84-1.233A5.69 5.69 0 0 1 9.005 2.2c.793 0 1.552.152 2.266.46.694.3 1.309.712 1.833 1.237.525.526.936 1.14 1.236 1.835.308.715.46 1.474.46 2.268 0 .791-.151 1.548-.457 2.26a5.9 5.9 0 0 1-1.233 1.838A5.76 5.76 0 0 1 9 13.8c-.792 0-1.548-.15-2.26-.456a5.84 5.84 0 0 1-3.084-3.087Zm8.742-5.653a4.841 4.841 0 0 0-1.523-1.026 4.663 4.663 0 0 0-1.87-.378c-.662 0-1.285.125-1.868.375A4.893 4.893 0 0 0 5.606 4.6a4.764 4.764 0 0 0-1.407 3.394c0 .663.125 1.286.375 1.87a4.84 4.84 0 0 0 2.56 2.561c.582.25 1.204.375 1.865.375a4.76 4.76 0 0 0 3.4-1.406 4.897 4.897 0 0 0 1.025-1.529c.25-.582.375-1.203.375-1.865 0-.664-.126-1.288-.377-1.872a4.848 4.848 0 0 0-1.025-1.524Z" clip-rule="evenodd"/>
			<path fill="red" d="M9.45 7.625V5.45a.437.437 0 0 0-.13-.32.432.432 0 0 0-.318-.13.44.44 0 0 0-.322.13.432.432 0 0 0-.13.32v2.363c0 .066.012.127.037.181a.495.495 0 0 0 .1.144L10.36 9.81c.093.093.2.137.32.133A.461.461 0 0 0 11 9.8a.437.437 0 0 0-.005-.64L9.449 7.625ZM9 12.8a4.673 4.673 0 0 1-1.866-.375 4.84 4.84 0 0 1-2.56-2.562A4.691 4.691 0 0 1 4.2 7.994 4.764 4.764 0 0 1 5.605 4.6a4.893 4.893 0 0 1 1.531-1.025A4.691 4.691 0 0 1 9.005 3.2c.663 0 1.286.126 1.87.378.583.252 1.09.594 1.522 1.026.431.432.773.94 1.025 1.524.251.584.377 1.208.377 1.872 0 .662-.125 1.283-.375 1.865a4.897 4.897 0 0 1-1.025 1.529A4.76 4.76 0 0 1 9 12.8Z"/>
		</g>
	</g>
	<defs>
		<filter id="a" width="17.6" height="17.6" x=".199" y=".2" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
			<feFlood flood-opacity="0" result="BackgroundImageFix"/>
			<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
			<feOffset dy="1"/>
			<feGaussianBlur stdDeviation="1.5"/>
			<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
			<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1269_14598"/>
			<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
			<feOffset dy="2"/>
			<feGaussianBlur stdDeviation=".5"/>
			<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
			<feBlend in2="effect1_dropShadow_1269_14598" result="effect2_dropShadow_1269_14598"/>
			<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
			<feOffset dy="1"/>
			<feGaussianBlur stdDeviation=".5"/>
			<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
			<feBlend in2="effect2_dropShadow_1269_14598" result="effect3_dropShadow_1269_14598"/>
			<feBlend in="SourceGraphic" in2="effect3_dropShadow_1269_14598" result="shape"/>
		</filter>
	</defs>
</svg>`;
const MapyPubtTypeItem$1 = /*@__PURE__*/ proxyCustomElement(class MapyPubtTypeItem extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.delay = false;
  }
  render() {
    return (h(Host, null, h("slot", null), this.delay ? h("div", { innerHTML: DELAY_ICON, class: "delay" }) : null));
  }
  static get style() { return mapyPubtTypeItemCss; }
}, [1, "mapy-pubt-type-item", {
    "delay": [516]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-pubt-type-item"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-pubt-type-item":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyPubtTypeItem$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyPubtTypeItem = MapyPubtTypeItem$1;
const defineCustomElement = defineCustomElement$1;

export { MapyPubtTypeItem, defineCustomElement };

//# sourceMappingURL=mapy-pubt-type-item.js.map